export default __webpack_public_path__ + "static/media/cs_icon_03.efefbb9d.png";